module.exports = __webpack_public_path__ + "img/bg-footer-comm.7cf549a5.jpg";